
import { Box, Button, Paper } from "@mui/material";
import { Typography } from "components/ui";
import React from "react";

const BottleResult = ({
    displayResult,
    isDone,
    lastModeResult,
    luckyUser,
    isMyTurn,
    myPrivileges,
    handleSkipDare,
    handleConfirmTask,
}) => {
    return (
        <Box sx={{ mt: 3, width: "100%", textAlign: "center" }}>
            <Paper
                elevation={6}
                sx={{
                    p: 3,
                    textAlign: "center",
                    bgcolor: isDone ? "#e8f5e9" : "#fff3e0",
                    borderRadius: 4,
                    border: isDone ? "3px solid #4caf50" : "none",
                    width: "100%",
                }}
            >
                <Typography $bolds color="primary">
                    4. ผลลัพธ์
                </Typography>
                <Box sx={{ my: 3 }}>
                    <Typography
                        $size="1.4em"
                        $bolds
                        color="#d32f2f"
                        sx={{ lineHeight: 1.4 }}
                    >
                        {lastModeResult === "dare"
                            ? `${luckyUser?.name} ดื่ม ${displayResult}`
                            : `"${displayResult}"`}
                    </Typography>
                </Box>

                <Box sx={{ mt: 2, display: "flex", gap: 2 }}>
                    {lastModeResult === "dare" && (
                        <Button
                            variant="outlined"
                            color="warning"
                            fullWidth
                            disabled={isDone || !isMyTurn || (myPrivileges?.skipD || 0) <= 0}
                            sx={{ borderRadius: 2, flex: 1 }}
                            onClick={handleSkipDare}
                        >
                            ข้าม ({myPrivileges?.skipD || 0})
                        </Button>
                    )}
                    <Button
                        variant="contained"
                        color={isDone ? "success" : "primary"}
                        fullWidth
                        size="large"
                        disabled={isDone || !isMyTurn}
                        onClick={handleConfirmTask}
                        sx={{ borderRadius: 2, flex: 1 }}
                    >
                        {isDone ? "เสร็จสิ้น! ✨" : "ยืนยัน"}
                    </Button>
                </Box>
            </Paper>
        </Box>
    );
};

export default BottleResult;
